
import React, { useState, useRef, useEffect } from 'react';
import VendorNav from '../../../Homepage/Components/VendorNav'
import 'react-phone-input-2/lib/style.css'
import { getVendorProfile, updateVendorProfile } from '../../../API_Handler'
import { useToast } from '../../../../Common/ToastContext';
import { getCurrentUser, updatePassword } from 'aws-amplify/auth';
import { PasswordTurnInvisibleIcon, PasswordTurnVisibleIcon } from '../../../../Constants/Icons';

const styles = {
  container: "w-full flex flex-col relative",
  profileHeader: "mt-8 mx-8",
  headerText: "mt-[32px] w-full text-xl md:text-3xl 2xl:text-3xl pb-2 vendor-header vendor-header-border font-proximanova",
  loadingContainer: "absolute flex flex-col items-center justify-center h-[50rem] w-full",
  spinner: "animate-spin rounded-full h-28 w-28 border-t-2 border-b-2",
  errorContainer: "absolute flex flex-col items-center justify-center h-[50rem] w-full",
  errorText: "text-lg md:text-xl 2xl:text-2xl text-red-600",
  formContainer: "flex flex-col items-center justify-center p-6 w-[80vw] mx-auto mb-12 bg-white",
  formHeader: "w-full flex justify-end mt-4",
  buttonBase: "text-white text-lg xl:text-xl font-semibold mx-2 px-4 xl:px-5 py-2 xl:py-3 bg-link hover:bg-charmHover w-fit",
  inputContainer: "w-full mx-auto my-2 flex flex-col items-center font-proxima-nova",
  label: "w-full text-left text-base text-gray-800 font-bold mb-2 font-proxima-nova",
  input: "block py-2.5 px-4 w-full text-base text-gray-900 border border-neutral appearance-none focus:outline-none focus:ring-0 focus:border-[#e1e4e8] font-proxima-nova",
  textarea: "h-36 block py-2.5 px-4 w-full text-base text-gray-900 border border-neutral appearance-none focus:outline-none focus:ring-0 focus:border-[#e1e4e8] font-proxima-nova",
  select: "block py-2.5 px-4 w-full text-base text-gray-900 border border-neutral appearance-none focus:outline-none focus:ring-0 focus:border-[#e1e4e8] font-proxima-nova"
}

const ProfileDetails = ({ vendorNavHidden }) => {
  const showToast = useToast();
  const [vendorData, setVendorData] = useState(null);
  const [newVendorData, setNewVendorData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [updatePasswordModal, setUpdatePasswordModal] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const retrieveVendor = async () => {
    try {
      const retrieveVendorInformation = await getVendorProfile(showToast);
      setVendorData(retrieveVendorInformation);
      setNewVendorData(retrieveVendorInformation);
      setLoading(false);

    } catch (error) {
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    retrieveVendor()
  }, []);

  const updateVendor = async () => {
    setEditLoading(true)
    try {
      const updateVendorInformation = await updateVendorProfile(newVendorData, showToast);
    } catch (error) {
    }
    setEditLoading(false)
  }

  const handleUpdatePassword = async () => {
    setErrorMessage('');
    setSuccessMessage('');
    try {
      const user = await getCurrentUser();
      await updatePassword({
        user, oldPassword, newPassword
      });
      setSuccessMessage('Password updated successfully.');
      setUpdatePasswordModal(false);
      setOldPassword('');
      setNewPassword('');
      setConfirmNewPassword('');
      setPasswordValidation({
        hasNumber: false,
        hasSpecialChar: false,
        hasUppercase: false,
        hasLowercase: false,
        longEnough: false,
        isPasswordMatch: false,
      });
      setErrorMessage('');
    } catch (error) {
      setErrorMessage(error.message || 'An error occurred while updating the password.');
    }
  };

  const handleCancelPasswordUpdate = () => {
    setUpdatePasswordModal(false);
    setOldPassword('');
    setNewPassword('');
    setConfirmNewPassword('');
    setPasswordValidation({
      hasNumber: false,
      hasSpecialChar: false,
      hasUppercase: false,
      hasLowercase: false,
      longEnough: false,
      isPasswordMatch: false,
    });
    setErrorMessage('');
    setSuccessMessage('');
    setIsOldPasswordVisible(false);
    setIsNewPasswordVisible(false);
    setIsConfirmNewPasswordVisible(false);
  }

  const [isOldPasswordVisible, setIsOldPasswordVisible] = useState(false);
  const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
  const [isConfirmNewPasswordVisible, setIsConfirmNewPasswordVisible] = useState(false);

  const [passwordValidation, setPasswordValidation] = useState({
    hasNumber: false,
    hasSpecialChar: false,
    hasUppercase: false,
    hasLowercase: false,
    longEnough: false,
    isPasswordMatch: false,
  });

  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    validatePassword(value, confirmNewPassword);
    setErrorMessage('');
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmNewPassword(value);
    validatePassword(newPassword, value);
    setErrorMessage('');
  };

  const validatePassword = (password, confirmPassword) => {
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const longEnough = password.length >= 8;
    const isPasswordMatch = password === confirmPassword;

    setPasswordValidation({
      hasNumber,
      hasSpecialChar,
      hasUppercase,
      hasLowercase,
      longEnough,
      isPasswordMatch,
    });
  };


  return (
    <div className="w-full flex flex-col relative">
      {!vendorNavHidden && <VendorNav navbarColor="#26051C" />}

      <div className="w-full flex flex-col">
        {!vendorNavHidden &&
          <div className="w-full px-basePx xs:px-xsPx 1.5xl:px-[104px]">
            <h3 className="mt-[32px] 1.5xl:text-[30px] text-[#505050] font-allroundgothic font-[700] mb-0">My Vendor Profile</h3>
          </div>}
        {(loading || editLoading) ? (
          <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only text-black">Loading...</span>
            </div>
          </div>
        ) : error ? (
          <div className="absolute w-full flex flex-col items-center justify-center">
            <p className="mt-[100px] font-proximanova text-[18px] text-red mb-0">Error retrieving vendor information. Please try refreshing the page or try again later.</p>
          </div>
        ) : (
          <div className="mt-[16px] w-full flex flex-col items-center justify-center px-basePx xs:px-xsPx 1.5xl:px-[104px] mx-auto mb-12">
            <div className="w-full flex flex-col sm:flex-row justify-end gap-[16px] xl:gap-[32px]">
              <button onClick={() => setUpdatePasswordModal(true)}
                className="w-full sm:w-fit text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4">
                Update Password
              </button>

              {!isEditMode ? (
                <button
                  className="w-full sm:w-fit text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4"
                  onClick={() => setIsEditMode(!isEditMode)}>
                  Edit my info
                </button>
              ) : (
                <div className="flex flex-row justify-end gap-[16px] xl:gap-[32px]">
                  <button className="w-fit text-white bg-[#76da24] hover:bg-charmHover hover:text-integrationRequestTextHover  rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4"
                    onClick={() => {
                      updateVendor();
                      setIsEditMode(!isEditMode);
                      setVendorData(newVendorData);
                    }}
                    disabled={editLoading}
                  >
                    Save
                  </button>

                  <button className="w-fit text-white bg-[#fd5764] hover:bg-charmHover hover:text-integrationRequestTextHover  rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4"
                    onClick={() => {
                      setIsEditMode(!isEditMode);
                      setNewVendorData(vendorData);
                    }}>
                    Cancel
                  </button>
                </div>
              )}
            </div>

            {updatePasswordModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="w-[90%] sm:w-[25rem] bg-white p-[12px] sm:p-[24px] flex flex-col ">
                  <h5 className="w-full text-left font-proximanova font-[600] text-[22px] text-[#505050]">Update Password</h5>
                  <label className="w-full text-left font-proximanova font-[400] text-[18px] text-[#404040] mb-1">Old Password</label>
                  <div className="relative">
                    <input
                      type={isOldPasswordVisible ? 'text' : 'password'}
                      className={`w-full h-[44px] rounded-none pl-[12px] pr-[32px] font-proximanova text-[18px] border-[1px] border-[#e1e4e8] focus:border-charmOrange focus:outline-none`}
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                    />
                    <span onClick={() => setIsOldPasswordVisible(!isOldPasswordVisible)} className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer">
                      {isOldPasswordVisible ? <PasswordTurnVisibleIcon /> : <PasswordTurnInvisibleIcon />}
                    </span>
                  </div>

                  <label className="mt-[8px] w-full text-left font-proximanova font-[400] text-[18px] text-[#404040] mb-1">New Password</label>
                  <div className="relative">
                    <input
                      type={isNewPasswordVisible ? 'text' : 'password'}
                      className={`w-full h-[44px] rounded-none pl-[12px] pr-[32px] font-proximanova text-[18px] border-[1px] border-[#e1e4e8] focus:border-charmOrange focus:outline-none`}
                      value={newPassword}
                      onChange={handleNewPasswordChange}
                    />
                    <span onClick={() => setIsNewPasswordVisible(!isNewPasswordVisible)} className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer">
                      {isNewPasswordVisible ? <PasswordTurnVisibleIcon /> : <PasswordTurnInvisibleIcon />}
                    </span>
                  </div>

                  <div className="mt-[8px] w-full flex flex-col gap-[1px]">
                    <p className={`font-proximanova text-[15px] mb-0 ${passwordValidation.hasNumber ? 'text-[#76da24]' : 'text-[#fd5764]'}`}>
                      • Contains at least 1 number
                    </p>
                    <p className={`font-proximanova text-[15px] mb-0 ${passwordValidation.hasSpecialChar ? 'text-[#76da24]' : 'text-[#fd5764]'}`}>
                      • Contains at least 1 special character
                    </p>
                    <p className={`font-proximanova text-[15px] mb-0 ${passwordValidation.hasUppercase ? 'text-[#76da24]' : 'text-[#fd5764]'}`}>
                      • Contains at least 1 uppercase letter
                    </p>
                    <p className={`font-proximanova text-[15px] mb-0 ${passwordValidation.hasLowercase ? 'text-[#76da24]' : 'text-[#fd5764]'}`}>
                      • Contains at least 1 lowercase letter
                    </p>
                    <p className={`font-proximanova text-[15px] mb-0 ${passwordValidation.longEnough ? 'text-[#76da24]' : 'text-[#fd5764]'}`}>
                      • Contains at least 8 characters
                    </p>
                  </div>

                  <label className="mt-[8px] w-full text-left font-proximanova font-[400] text-[18px] text-[#404040] mb-1">Confirm New Password</label>
                  <div className="relative">
                    <input
                      type={isConfirmNewPasswordVisible ? 'text' : 'password'}
                      className={`w-full h-[44px] pl-[12px] pr-[32px] rounded-none font-proximanova text-[18px] border-[1px] border-[#e1e4e8] focus:border-charmOrange focus:outline-none`}
                      value={confirmNewPassword}
                      onChange={handleConfirmPasswordChange}
                    />
                    <span onClick={() => setIsConfirmNewPasswordVisible(!isConfirmNewPasswordVisible)} className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer">
                      {isConfirmNewPasswordVisible ? <PasswordTurnVisibleIcon /> : <PasswordTurnInvisibleIcon />}
                    </span>
                  </div>

                  <p className={`mt-[8px] font-proximanova text-[15px] mb-0 ${passwordValidation.isPasswordMatch ? 'text-[#76da24]' : 'text-[#fd5764]'}`}>
                    {passwordValidation.isPasswordMatch ? '' : '• Passwords do not match'}
                  </p>

                  <div className="mt-[16px] w-full flex flex-row justify-center gap-[16px]">
                    <button
                      className="w-fit text-white bg-[#76da24] hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4"
                      onClick={handleUpdatePassword}
                    >
                      Submit
                    </button>
                    <button
                      className="w-fit text-white bg-[#fd5764] hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4"
                      onClick={handleCancelPasswordUpdate}
                    >
                      Cancel
                    </button>
                  </div>
                  {errorMessage && <p className="text-[18px] font-proximanova text-[#fd5764] mt-3">{errorMessage}</p>}
                  {successMessage && <p className="text-[18px] font-proximanova text-[#76da24] mt-3">{successMessage}</p>}
                </div>
              </div>
            )}

            <div className="mt-[16px] w-full flex flex-col">
              <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Vendor Name</label>
              <input
                type="text"
                className={`w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] ${isEditMode ? 'bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none' : ''}`}
                value={newVendorData.company_name}
                onChange={(e) => setNewVendorData({ ...newVendorData, company_name: e.target.value })}
                placeholder="Vendor Name"
                disabled={!isEditMode}
              />
              <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Vendor Description</label>
              <textarea
                className={`w-full h-fit rounded-none block p-2 font-proximanova text-[18px] ${isEditMode ? 'bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none' : ''}`}
                value={newVendorData.vendor_bio}
                onChange={(e) => setNewVendorData({ ...newVendorData, vendor_bio: e.target.value })}
                placeholder="Description"
                disabled={!isEditMode}
              />
              <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Vendor Website</label>
              <input
                className={`w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] ${isEditMode ? 'bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none' : ''}`}
                value={newVendorData.website}
                onChange={(e) => setNewVendorData({ ...newVendorData, website: e.target.value })}
                placeholder="Website"
                disabled={!isEditMode}
              />
              <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Year Founded</label>
              <input
                className={`w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] ${isEditMode ? 'bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none' : ''}`}
                value={newVendorData.year_founded}
                onChange={(e) => setNewVendorData({ ...newVendorData, year_founded: e.target.value })}
                disabled={!isEditMode}
              />
              <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Number of Employees</label>
              {
                isEditMode ? (
                  <select
                    value={newVendorData.number_of_employees}
                    onChange={(e) => setNewVendorData({ ...newVendorData, number_of_employees: e.target.value })}
                    className={`w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] ${isEditMode ? 'bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none' : ''}`}
                    disabled={!isEditMode}
                  >
                    <option value="" disabled>Select Number of Employees</option>
                    <option value="0-50">0-50</option>
                    <option value="51-100">51-100</option>
                    <option value="100-500">100-500</option>
                    <option value="500+">500+</option>
                  </select>
                ) :
                  <p className="w-full h-[40px] rounded-none p-2 font-proximanova text-[18px] mb-0">
                    {newVendorData.number_of_employees}
                  </p>
              }
              <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Revenue Range</label>
              {
                isEditMode ? (
                  <select
                    value={newVendorData.revenue}
                    onChange={(e) => setNewVendorData({ ...newVendorData, revenue: e.target.value })}
                    className={`w-full h-[40px] rounded-none p-2 bg-white font-proximanova text-[18px] rounded-none ${isEditMode ? 'border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none' : 'border-[1px] border-white'}`}
                    disabled={!isEditMode}
                  >
                    <option value="" disabled>Select Revenue Range</option>
                    <option value="0-149999">$0 - $149,999</option>
                    <option value="150000-299999">$150,000 - $299,999</option>
                    <option value="300000-449999">$300,000 - $449,999</option>
                    <option value="450000-599999">$450,000 - $599,999</option>
                    <option value="600000-749999">$600,000 - $749,999</option>
                    <option value="750000-899999">$750,000 - $899,999</option>
                    <option value="900000-1049999">$900,000 - $1,049,999</option>
                    <option value="1050000-1199999">$1,050,000 - $1,199,999</option>
                    <option value="1200000-1349999">$1,200,000 - $1,349,999</option>
                    <option value="1350000-1499999">$1,350,000 - $1,499,999</option>
                    <option value="1500000+">$1,500,000+</option>
                  </select>
                ) :
                  <p className="w-full h-[40px] rounded-none p-2 font-proximanova text-[18px] mb-0">
                    {newVendorData.revenue}
                  </p>
              }
              <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Service Specialties</label>
              < input
                className={`w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] ${isEditMode ? 'bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none' : ''}`}
                value={newVendorData.service_specialties}
                onChange={(e) => setNewVendorData({ ...newVendorData, service_specialties: e.target.value })}
                disabled={!isEditMode}
              />
              < label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Service Description</label>
              < input
                className={`w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] ${isEditMode ? 'bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none' : ''}`}
                value={newVendorData.service_description}
                onChange={(e) => setNewVendorData({ ...newVendorData, service_description: e.target.value })}
                disabled={!isEditMode}
              />
              < label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Goal</label>
              < textarea
                className={`w-full h-fit rounded-none block p-2 font-proximanova text-[18px] ${isEditMode ? 'bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none' : ''}`}
                value={newVendorData.serve_plan}
                onChange={(e) => setNewVendorData({ ...newVendorData, serve_plan: e.target.value })}
                disabled={!isEditMode}
              />

              < label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">API Interest</label>
              {
                isEditMode ? (
                  <select
                    className={`w-full h-[40px] rounded-none p-2 bg-white font-proximanova text-[18px] rounded-none ${isEditMode ? 'border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none' : 'border-[1px] border-white'}`}
                    value={newVendorData.has_api_interest === null ? false : newVendorData.has_api_interest}
                    onChange={(e) => setNewVendorData({ ...newVendorData, has_api_interest: e.target.value })}
                    disabled={!isEditMode}
                  >
                    <option value={true}>IS Interested in APIs</option>
                    <option value={false}>IS NOT Interested in APIs</option>
                  </select>
                ) :
                  <p className="w-full h-[40px] rounded-none p-2 font-proximanova text-[18px] mb-0">
                    {newVendorData.has_api_interest === true ? "Interested in API program" : "Not interested in API program"}
                  </p>
              }

              <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Title</label>
              < input
                className={`w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] ${isEditMode ? 'bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none' : ''}`}
                value={newVendorData.title}
                onChange={(e) => setNewVendorData({ ...newVendorData, title: e.target.value })}
                disabled={!isEditMode}
              />
              < label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Contact Name</label>
              < input
                className={`w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] ${isEditMode ? 'bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none' : ''}`}
                value={newVendorData.contact_name}
                onChange={(e) => setNewVendorData({ ...newVendorData, contact_name: e.target.value })}
                disabled={!isEditMode}
              />
              < label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Contact Email</label>
              < p className="w-full h-[40px] rounded-none p-2 bg-[#DCDCDC] font-proximanova text-[#6D6D6D] text-[18px] border-[1px] border-white mb-0" >
                {newVendorData.contact_email}
              </p >
              <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Contact Phone</label>
              < input
                className={`w-full h-[44px] rounded-none p-2 font-proximanova text-[18px] ${isEditMode ? 'bg-white border-[#e1e4e8] border-[1px] focus:border-charmOrange focus:outline-none focus:border-charmOrange focus:outline-none' : ''}`}
                value={newVendorData.contact_phone_number}
                onChange={(e) => setNewVendorData({ ...newVendorData, contact_phone_number: e.target.value })}
                disabled={!isEditMode}
              />
              < label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1">Approval Status</label>
              < p className="w-full h-[40px] rounded-none p-2 bg-[#DCDCDC] font-proximanova text-[#6D6D6D] text-[18px] border-[1px] border-white mb-0" style={{ lineHeight: '1.35' }}>
                {newVendorData.approval_status}
              </p >

            </div >
          </div >
        )}
      </div >
    </div >

  );
};

export default ProfileDetails;